<template>
    <div class="clothes-content content-box">

        <div class="clothes-head">
            <div class="head-box" :class="tabActive==group.groupId?'active':''" v-for="group in groupList" :key="group.groupId" @click="tabActive=group.groupId">{{group.groupName}}</div>
        </div>
        <div class="clothes-tab">
            <div v-for="typeObj in typeList" :key="typeObj.id" >
                <div class="type_box" v-if="typeObj.group==tabActive">
                    <div class="type_title"><i></i>{{typeObj.name}}<span @click="cutTypeMenu(typeObj)" style="font-size: 30px;">{{typeObj.show?'-':'+'}}</span></div>
                    <div class="type_content" v-if="typeObj.show">
                        <ul class="tab_ul">
                            <li>
                                <fileUpload :id="'clothes_'+typeObj.type" :data="typeObj" accept=".zip" typefolder="drogue" parentfolder="zip_resource" @checkfile="checkfile" @progress="uploadProgress" @error="uploadError" @success="uploadSuccess"></fileUpload>
                                <span class="type-add">+</span>
                                <div class="upload-back" v-if="typeObj.loading">{{typeObj.progress}}%</div>
                                <div class="tab_div">点击上传</div>
                            </li>
                            <li v-for="(clothes,index) in typeObj.list" :key="index" :style="{ 'background-image': 'url(' + clothes.partsPhoto + '?x-oss-process=style/fmslt)' }" @click="cutClothes(clothes)">
                                <div class="upload-back" v-if="clothes.loading">{{clothes.progress}}%</div>
                                <div class="tab_div">{{clothes.partsName}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div >
            <center v-if="clothes.length<=0" >
                
                <img src="@/assets/images/null.png"/>
                <div style="font-weight:600">当前角色不支持换装</div>
            </center>
            
        </div> -->
        
    </div>
</template>
<script>
import fileUpload from '@/components/ali_oss/alioss.vue'
export default {
    name: 'Background',
    props:['modelClass','user'],
    components: {
      fileUpload,
    },
    data(){
        return {
            tabActive:"1",
            groupList:[
                {
                    groupId:"1",
                    groupName:"头部",
                },
                {
                    groupId:"2",
                    groupName:"身体",
                },
            ],
            typeList:[
                {    type:"1",name:"发型",group:"1",show:true,loading:false,progress:0,list:[]},
                {    type:"2",name:"脸型",group:"1",show:false,loading:false,progress:0,list:[]},
                {    type:"3",name:"眼镜",group:"1",show:false,loading:false,progress:0,list:[]},
                {    type:"4",name:"鼻子",group:"1",show:false,loading:false,progress:0,list:[]},
                {    type:"5",name:"嘴巴",group:"1",show:false,loading:false,progress:0,list:[]},
                {    type:"6",name:"发饰",group:"1",show:false,loading:false,progress:0,list:[]},
                {    type:"7",name:"耳饰",group:"1",show:false,loading:false,progress:0,list:[]},
                {    type:"8",name:"面饰",group:"1",show:false,loading:false,progress:0,list:[]},
                {    type:"9",name:"上衣",group:"2",show:false,loading:false,progress:0,list:[]},
                {    type:"10",name:"下衣",group:"2",show:false,loading:false,progress:0,list:[]},
                {    type:"11",name:"套装",group:"2",show:false,loading:false,progress:0,list:[]},
                {    type:"12",name:"鞋子",group:"2",show:false,loading:false,progress:0,list:[]},
                {    type:"13",name:"袜子",group:"2",show:false,loading:false,progress:0,list:[]},
                {    type:"14",name:"手腕饰品",group:"2",show:false,loading:false,progress:0,list:[]},
                {    type:"15",name:"身前饰品",group:"2",show:false,loading:false,progress:0,list:[]},
                {    type:"16",name:"身后饰品",group:"2",show:false,loading:false,progress:0,list:[]}
            ]
        }
    },
    mounted(){
     
        
    },
    created(){
        console.log(this.user);
        this.getPartList(this.typeList[0]);
    },
    methods:{

        cutTypeMenu(obj){
            obj.show=!obj.show;
            if(obj.show&&obj.list.length<=0){
                this.getPartList(obj);
            }
        },
        //获取配饰列表
        getPartList(obj){
            var that=this;
            this.post("/parts/findPartsList",{modelId:this.user.modelId,type:obj.type,pageIndex:0,pageSize:1000}).then((res)=>{
                if (res.status == "200") {
                    var list=res.data[0];
                    for(var a=0;a<list.length;a++){
                        list[a].loading=false;
                        list[a].progress=0;
                    }
                    obj.list=list;
                }else{
                    that.$message.error("获取失败！")
                }
            })
            .catch(()=>{
                that.$message.error("获取异常！")
            })
        },

        //换装
        cutClothes(clothes){
            var list=[];
            list.push(JSON.parse(clothes.partsJson));
            this.modelClass.dbClothe(list,function(progress){
                clothes.progress=parseInt(progress*100);;
            },function(){
                clothes.loading=false;
                console.log("换装成功！")
            });
        },

        //文件选择成功
        checkfile(file,obj){
            // this.loglist=[];
            obj.loading=true;
            obj.progress=0;
            this.putLog("已选择文件："+file.name)
            this.putLog("正在上传中...")
        },

        //上传进度
        uploadProgress(progress,obj){
            obj.progress=parseInt(progress*100);
            if(progress==1){
                this.putLog("文件正在上传，已完成"+parseInt(progress*100)+"%",1)
                this.putLog("文件上传完成，正在校验文件是否可用...")
            }else{
                this.putLog("文件正在上传，已完成"+parseInt(progress*100)+"%",1)
            }
        },

        //上传失败
        uploadError(error,obj){
            obj.loading=false;
            this.$message.error("上传失败！")
            this.putLog("文件上传失败！")
            console.log(error);
        },

        //上传成功
        uploadSuccess(json,obj){
            console.log(json);
            obj.loading=false;
           if(json.fileDir.length<=0){
               this.putLog("上传文件不可用，请检查该文件是否为龙骨配件压缩包！")
               this.$message.warning("上传文件不可用，请检查该文件是否为龙骨配件压缩包！")
           }else{
               this.putLog("文件校验成功！")
                this.$message.success("文件上传成功！")
                this.putLog("文件校验成功，正在渲染到舞台请稍后...")
                
                console.log(obj);

                this.saveParts(json,obj)
                
          }
        },

        //保存
        saveParts(json,obj){
            var that=this;
            var cover=0;
            for(var a=0;a<json.fileList.length;a++){
                if(json.fileList[a].indexOf(".png")!=-1){
                   cover=json.fileUrl.split("drogue/zip")[0]+json.fileDir + json.fileList[a];
                   break;
                }
            };
            
            var param={
                partsName:json.fileName.split(".")[0],
                partsJson:JSON.stringify(json),
                partsPhoto:cover,
                groupType:obj.group,
                type:obj.type,
                sortCode:0,
                modelId:this.user.modelId
            }
            console.log(param)
            this.post("/parts/save",param).then((res)=>{
                if (res.status == "200") {
                    that.$message.success("保存成功！")
                    obj.list.push(res.data);
                }else{
                    that.$message.error("保存失败！")
                }
            })
            .catch(()=>{
                that.$message.error("保存异常！")
            })
        },

        //日志
        putLog(txt,index){
          var a=new Date();
          var hourse=a.getHours();
          var min=a.getMinutes();
          var second=a.getSeconds()

          var logtxt="【"+(hourse<10?'0'+hourse:hourse)+":"+(min<10?'0'+min:min)+":"+(second<10?'0'+second:second)+"】"+txt;
        console.log(logtxt);
        
        //  //替换
        //   if(index==undefined){
        //       this.loglist.push(logtxt)
              
        //   }else{
        //       this.loglist[index]=logtxt;
        //   }
          
      },


    }
}
</script>

<style lang="scss" scoped>

.clothes-content{
    
    .clothes-head{
        display: flex;
        border-bottom: 1px solid #eee;
        text-align: center;
        .head-box{
            // width: 50%;
            padding: 10px;
            cursor: pointer;
        }
        .head-box.active{
            border-bottom: 2px solid #eb9fa9;
        }
    }
    .clothes-tab{

        .type_box{
            padding: 10px;
            border: 1px solid #eb9fa93d;
            margin: 10px 0;
            border-radius: 4px;
        }
        .type_title {
            
            height: 24px;
            line-height: 24px;
            font-size: 16px;
            color: #eb9fa9;
            display: flex;
            align-items: center;
            position: relative;
            i {
                display: inline-block;
                width: 4px;
                background: #eb9fa9;
                height: 18px;
                border-radius: 5px;
                margin-right: 10px;
            }
            span{
                cursor: pointer;
                font-size: 20px;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                color: #eb9fa9;
                border-radius: 50%;
                position: absolute;
                right: 0;
            }
        }
        .type_content{
            margin: 10px;
            .tab_ul {
                background: #fff;
                display: flex;
                flex-wrap: wrap;
                border-radius: 5px;

                li {
                    background: #F6F6FB;
                    width: 95px;
                    margin-right: 12px;
                    height: 95px;
                    border-radius: 20px;
                    cursor: pointer;
                    position: relative;
                    color: #585858;
                    margin-bottom: 50px;
                    text-align: center;
                    .tab_div {
                        position: absolute;
                        bottom: -35px;
                        left: 50%;
                        color: #585858;
                        transform: translate(-50%);
                        overflow: hidden;
                        font-size: 16px;
                        width: 100%;
                        text-align: center;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .type-add{
                    font-size: 50px;
                    color: #ccc;
                    line-height: 95px;
                }
                .upload-back{
                    width: 100%;
                    height: 100%;
                    line-height: 95px;
                    background-color: #4040407a;
                    color: #fff;
                    font-size: 18px;
                    top: 0;
                    position: absolute;
                    left: 0;
                    border-radius: 20px;
                }
            }
            
        }
    }
}
    
</style>
